export default __webpack_public_path__ + "static/media/Block_1.9eef3089.webp";